// frontend/src/components/Cards/SummaryCardWithPieChart.js

import React from 'react';
import { Paper, Box, Typography, Tooltip, IconButton } from '@mui/material';
import PieChartComponent from '../Charts/PieChart';
import { useTheme, alpha } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SummaryCardWithPieChart = ({
    icon: Icon,
    label,
    percentage,
    color,
    tooltip,
    compact = false,
    sx, // Accept sx prop for custom styling
}) => {
    const theme = useTheme();
    return (
        <Paper
            elevation={compact ? 0 : 3}
            sx={{
                p: compact ? 1.25 : 3,
                borderRadius: 2,
                backgroundColor: compact ? '#fcfcfd' : '#fff',
                border: compact ? '1px solid' : 'none',
                borderColor: compact ? 'divider' : 'transparent',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: compact ? 'stretch' : 'center',
                height: '100%', // Allow card to fill parent height
                overflow: 'hidden',
                ...sx, // Apply custom styles if any
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: compact ? 0.75 : 2 }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: compact ? 30 : 56,
                        width: compact ? 30 : 56,
                        backgroundColor: compact ? alpha(color, 0.12) : color,
                        color: compact ? color : '#fff',
                        borderRadius: compact ? 1.25 : '50%',
                        mr: compact ? 1.25 : 2,
                    }}
                >
                    <Icon fontSize={compact ? 'small' : 'large'} />
                </Box>
                <Typography
                    variant={compact ? 'body2' : 'h6'}
                    sx={{ fontWeight: 700, color: theme.palette.text.primary, lineHeight: 1.2 }}
                >
                    {label}
                </Typography>
                {tooltip && (
                    <Tooltip title={tooltip} arrow>
                        <IconButton size="small" sx={{ ml: 0.25, p: compact ? 0.25 : 0.5 }}>
                            <InfoOutlinedIcon fontSize="small" color="action" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            {compact ? (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.25 }}>
                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            Current rate
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: 800, color }}>
                            {percentage}%
                        </Typography>
                    </Box>
                    <Box sx={{ width: 76, height: 76 }}>
                        <PieChartComponent percentage={percentage} compact={compact} />
                    </Box>
                </Box>
            ) : (
                <>
                    <Typography variant="h2" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
                        {percentage}%
                    </Typography>
                    <Box sx={{ width: '250px', height: '250px', mt: 2 }}>
                        <PieChartComponent percentage={percentage} compact={compact} />
                    </Box>
                </>
            )}
            {tooltip && !compact && (
                <Tooltip title={tooltip} arrow>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1, textAlign: 'center' }}>
                        {tooltip}
                    </Typography>
                </Tooltip>
            )}
        </Paper>
    );
};

export default SummaryCardWithPieChart;
